__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__GoEIuG__accordion",
  "content": "accordion-module-scss-module__GoEIuG__content",
  "contentText": "accordion-module-scss-module__GoEIuG__contentText",
  "expanded": "accordion-module-scss-module__GoEIuG__expanded",
  "tab": "accordion-module-scss-module__GoEIuG__tab",
  "tabContent": "accordion-module-scss-module__GoEIuG__tabContent",
  "tabHeader": "accordion-module-scss-module__GoEIuG__tabHeader",
  "tabHeaderIcon": "accordion-module-scss-module__GoEIuG__tabHeaderIcon",
  "title": "accordion-module-scss-module__GoEIuG__title",
  "titleSpan": "accordion-module-scss-module__GoEIuG__titleSpan",
});
